import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

export const veterinarySymptomObject = z.object({
  id: z.string().uuid(),
  title: z.string(),
  observations: z.string().nullish(),
  sourceFilter: z.string().nullish(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

// export const veterinarySymptomCreateInputObject = z.object({
//   id: z.string().uuid().nullish(),
//   title: z.string().min(1),
//   observations: z.string().nullish(),
//   createdAt: dateOrIsoString().nullish(),
//   updatedAt: dateOrIsoString().nullish(),
// })

// export const veterinarySymptomUpdateInputObject = z.object({
//   id: z.string().uuid(),
//   title: z.string().min(1).optional(),
//   observations: z.string().nullable().optional(),
//   updatedAt: dateOrIsoString().nullish(),
// })

export const propertyMap = {
  id: sql`veterinary_symptom.id`,
  title: sql`veterinary_symptom.title`,
  observations: sql`veterinary_symptom.observations`,
  sourceFilter: sql`veterinary_symptom.source_filter`,
  clientId: sql`veterinary_symptom.client_id`,
  insertUserId: sql`veterinary_symptom.insert_user_id`,
  editUserId: sql`veterinary_symptom.edit_user_id`,
  createdAt: sql`veterinary_symptom.created_at`,
  updatedAt: sql`veterinary_symptom.updated_at`,
  deletedAt: sql`veterinary_symptom.deleted_at`,
}

export type VeterinarySymptomType = z.infer<typeof veterinarySymptomObject>
